export const SET_CROSSSELL_ACTIVE_ID = 'CrossSell::setActiveId';
export const CLEAR_CROSSSELL_ACTIVE_ID = 'CrossSell::clearActiveId';

export const REQUEST_CROSSSELL_DETAILS = 'CrossSell::RequestDetails';
export const REQUEST_CROSSSELL_DETAILS_DONE = 'CrossSell::RequestDetails::Success';
export const REQUEST_CROSSSELL_DETAILS_ERROR = 'CrossSell::RequestDetails::Error';

/**
 * Link for OPS track
 */
export const REQUEST_OPS_TRACK_URL = '/shop/shopupsale/track/';
export const REQUEST_CROSSSELL_TRACK_OPEN = 'CrossSell::RequestOPSTrack::OpenState';
export const REQUEST_CROSSSELL_TRACK_ACTIVATION = 'CrossSell::RequestOPSTrack::ActivationState';

/** crossSell in tab */

export const UPDATE_CROSSSELL_CATEGORY_LIST = 'CrossSell::UpdateCategoryList';
export const SET_CROSSSELL_COUNT_TO_SHOW = 'CrossSell::SetCountToShow';
